import {
  ADDED,
  ADDEDPRODUCT,
  DECREMENT,
  INCREMENT,
  REMOVE,
} from "./actionTypes";

export const addedproduct = (item) => {
  return {
    type: ADDEDPRODUCT,
    payload: item,
  };
};

export const deleted = (todoId) => {
  return {
    type: REMOVE,
    payload: todoId,
  };
};

export const addedcart = (todoitem) => {
  return {
    type: ADDED,
    payload: todoitem,
  };
};
export const increment = (todoId) => {
  return {
    type: INCREMENT,
    payload: todoId,
  };
};
export const decrement = (todoId) => {
  return {
    type: DECREMENT,
    payload: todoId,
  };
};
